import { render, staticRenderFns } from "./transfer-callback.vue?vue&type=template&id=cfef8dde&lang=pug"
import script from "./transfer-callback.vue?vue&type=script&lang=js"
export * from "./transfer-callback.vue?vue&type=script&lang=js"
import style0 from "@ui-common/vue-spinner/dist/vue-spinner.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports